import { matomoTrackerId } from '../../../config';

const isMatomoInstalled = () => !!document.getElementById(matomoTrackerId);

export default isMatomoInstalled;
